import type { IconNode } from '../types';

/**
 * @name pig
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgNC41YTQuMTIgNC4xMiAwIDAgMC01LjUgMS42QzEzIDYgMTIuNSA2IDEyIDZjLTQuNCAwLTggMi43LTggNiAwIDEuNS44IDIuOSAyIDR2MmEyIDIgMCAwIDAgMiAyaDJ2LTIuMmExMi4zIDEyLjMgMCAwIDAgNCAwVjE5YzAgLjYuNCAxIDEgMWgzdi00Yy43LS42IDEuMi0xLjIgMS41LTJIMjFjLjYgMCAxLS40IDEtMXYtM2gtMi41Yy0uNC0xLTEuMi0xLjgtMi4yLTIuNVoiIC8+CiAgPHBhdGggZD0iTTE2IDExaC4wMSIgLz4KICA8cGF0aCBkPSJNMi4zIDdhMiAyIDAgMCAwIDIuMiAyLjkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/pig
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pig: IconNode = [
  [
    'path',
    {
      d: 'M19 4.5a4.12 4.12 0 0 0-5.5 1.6C13 6 12.5 6 12 6c-4.4 0-8 2.7-8 6 0 1.5.8 2.9 2 4v2a2 2 0 0 0 2 2h2v-2.2a12.3 12.3 0 0 0 4 0V19c0 .6.4 1 1 1h3v-4c.7-.6 1.2-1.2 1.5-2H21c.6 0 1-.4 1-1v-3h-2.5c-.4-1-1.2-1.8-2.2-2.5Z',
      key: '109nem',
    },
  ],
  ['path', { d: 'M16 11h.01', key: 'xkw8gn' }],
  ['path', { d: 'M2.3 7a2 2 0 0 0 2.2 2.9', key: '14sj11' }],
];

export default pig;
